import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import TruckColorIcon from '../../../../../../../common/icons/icr_envio.svg';
import MotiveTitle from '../MotiveTitle';
import NotReceived from '../../../forms/notReceived/NotReceived';

const NotReceivedMobile = ({ ...props }) => {
  const { motiveId, product, profile, onData } = props;

  return (
    <Box>
      <MotiveTitle
        icon={TruckColorIcon}
        title="Despacho y retiro"
        subtitle="No ha llegado mi producto"
        mobile
      />
      <NotReceived
        mobile
        motiveId={motiveId}
        product={product}
        profile={profile}
        type="1"
        onData={onData}
      />
    </Box>
  );
};

NotReceivedMobile.propTypes = {
  motiveId: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  onData: PropTypes.func,
};

export default NotReceivedMobile;
